import { sumBy } from 'lodash'


const Keys = {
  ADD_LOADING: 'add_loading',
  REMOVE_LOADING: 'remove_loading',
  UPDATE_LOADING: 'update_loading',
  CLEAR: 'clear',
  CHANGE_MINIMIZE: 'change_minimize',
  REMOVE_ALL: 'remove_all',
}

export const state = {
  loadingItems: [],
  isMinimized: false
}

export const mutations = {
  [Keys.ADD_LOADING](state, loadingItem) {
    if (!loadingItem) {
      return
    }

    state.loadingItems.push(loadingItem)

    if (state.loadingItems.length === 1)
      state.isMinimized = false
  },

  [Keys.REMOVE_LOADING](state, itemId) {
    if (!itemId) {
      return
    }

    state.loadingItems = state.loadingItems.filter(x => x.id !== itemId)
  },

  [Keys.UPDATE_LOADING](state, loadingItem) {
    if (!loadingItem) {
      return
    }

    const itemIndex = state.loadingItems.findIndex(x => x.id === loadingItem.id)

    if (itemIndex === -1) return

    state.loadingItems[itemIndex] = {
      ...state.loadingItems[itemIndex],
      ...loadingItem
    }
  },

  [Keys.CLEAR](state) {
    state.loadingItems = []
    state.isMinimized = false
  },

  [Keys.REMOVE_ALL](state) {
    if (state.loadingItems.every(x => x.progress === 100))
      state.loadingItems = []
  },


  [Keys.CHANGE_MINIMIZE](state, isMinimized) {
    state.isMinimized = isMinimized
  }
}
export const actions = {

  addLoadingItem({ commit }, loadingItem) {
    commit(Keys.ADD_LOADING, loadingItem)
  },
  removeLoadingItem({ commit }, itemId) {
    commit(Keys.REMOVE_LOADING, itemId)
  },
  updateLoadingItem({ commit }, loadingItem) {
    commit(Keys.UPDATE_LOADING, loadingItem)
  },
  clear({ commit }) {
    commit(Keys.CLEAR)
  },
  removeAll({ commit }) {
    commit(Keys.REMOVE_ALL)
  },
  changeMinimize({ commit }, newState) {
    commit(Keys.CHANGE_MINIMIZE, newState)
  },
}
export const getters = {
  all: state => {
    return state.loadingItems
  },
  getById: state => id => {
    return state.loadingItems.find(x => x.id === id)
  },
  isMinimized: state => {
    return state.isMinimized
  },
  getTotalPercent: state => {
    let allItems = sumBy(state.loadingItems, 'totalItems')
    let succeedItems = sumBy(state.loadingItems, 'succeedItems')

    return succeedItems * 100 / allItems
  },
  hasLoadingItem: state => {
    return state.loadingItems.length > 0
  },
  modalIsMinimizable: state => {
    return !state.loadingItems.some(x => !x.minimizable)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
